const firebaseConfig = {
    apiKey: "AIzaSyCTuyacv8LMloqqWMbC63f-axYbckKfeBU",
    authDomain: "octa-prd.firebaseapp.com",
    databaseURL: "https://octa-prd-default-rtdb.firebaseio.com",
    projectId: "octa-prd",
    storageBucket: "octa-prd.firebasestorage.app",
    messagingSenderId: "1009118995992",
    appId: "1:1009118995992:web:5e634406bd40f77f34456d"
};

export default firebaseConfig;